//------------------------------------------------------------------------------
// サイドバー リデューサー
//------------------------------------------------------------------------------
import { combineReducers } from 'redux';
import types from './types';

/**
 * サイドバー開閉状態
 */
const open = (state = false, action) => {
  switch (action.type) {
    case types.OPEN: return action.open;
    default: return state;
  }
};

// エクスポート
const reducers = combineReducers({
  open,
});
export default reducers;
